import React from "react";
import { useTranslation } from "react-i18next";
import useHackleInfo from "../../hooks/useHackle";
import A from "./A";

// 개념풀이 버튼
const HackleConceptBtn = (props) => {
  const { t } = useTranslation();
  const { info } = useHackleInfo();
  const { isShowHackle, variation } = info?.ANSWERING_QUESTIONS_BUTTON || {};

  if (!isShowHackle) return null;
  // console.log("variation", variation);
  return (
    <>
      {variation === "A" && <></>}
      {variation === "B" && (
        <div className="ask_area right">
          <A className="notion" onClick={props.onSelectConceptBtn}>
            {t("LC_04_01.msg019")}
          </A>
        </div>
      )}
    </>
  );
};

export default HackleConceptBtn;
